interface AtootbandanLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export function AtootbandanLogo({ className = '', size = 'md', showText = true }: AtootbandanLogoProps) {
  const sizeMap = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const textSizeMap = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="relative">
        {/* Main logo SVG - Two hearts intertwined representing union */}
        <svg 
          className={`${sizeMap[size]} text-rose-500`} 
          viewBox="0 0 100 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background circle with gradient */}
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#E91E63" />
              <stop offset="50%" stopColor="#EC4899" />
              <stop offset="100%" stopColor="#F472B6" />
            </linearGradient>
            <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FCA5A5" />
              <stop offset="100%" stopColor="#FDA4AF" />
            </linearGradient>
          </defs>
          
          {/* Outer decorative ring */}
          <circle cx="50" cy="50" r="45" stroke="url(#accentGradient)" strokeWidth="2" fill="none" opacity="0.3" />
          
          {/* Left heart */}
          <path 
            d="M 30 35 
               C 30 25, 20 20, 15 25 
               C 10 30, 10 35, 15 42
               L 30 60
               L 30 35 Z" 
            fill="url(#logoGradient)"
          />
          
          {/* Right heart */}
          <path 
            d="M 30 35
               C 30 25, 40 20, 45 25
               C 50 30, 50 35, 45 42
               L 30 60
               L 30 35 Z"
            fill="url(#logoGradient)"
          />
          
          {/* Center connecting element - infinity symbol */}
          <path
            d="M 35 50
               Q 40 45, 45 50
               Q 50 55, 55 50
               Q 60 45, 65 50
               Q 60 55, 55 50
               Q 50 45, 45 50
               Q 40 55, 35 50 Z"
            fill="url(#accentGradient)"
            opacity="0.6"
          />
          
          {/* Sparkle accents */}
          <circle cx="70" cy="30" r="2" fill="#FCA5A5">
            <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite" />
          </circle>
          <circle cx="80" cy="40" r="1.5" fill="#FDA4AF">
            <animate attributeName="opacity" values="0.5;1;0.5" dur="2.5s" repeatCount="indefinite" />
          </circle>
          <circle cx="25" cy="25" r="1.5" fill="#FCA5A5">
            <animate attributeName="opacity" values="0.4;1;0.4" dur="3s" repeatCount="indefinite" />
          </circle>
        </svg>
        
        {/* Animated pulse ring */}
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-r from-pink-400 to-rose-400 rounded-full animate-pulse"></div>
      </div>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`${textSizeMap[size]} font-bold bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent`}>
            Atootbandan
          </span>
          <span className="text-xs text-gray-500 italic -mt-1">
            Where Hearts Find Home
          </span>
        </div>
      )}
    </div>
  );
}
